import { render, staticRenderFns } from "./liventus.vue?vue&type=template&id=dc4f6a1c&scoped=true&"
import script from "./liventus.vue?vue&type=script&lang=js&"
export * from "./liventus.vue?vue&type=script&lang=js&"
import style0 from "./liventus.vue?vue&type=style&index=0&id=dc4f6a1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4f6a1c",
  null
  
)

export default component.exports